<template>
  <LayoutDefault>
    <div
            id="watch"
            class="container dark"
    >
      <template v-if="!loadingMovie && !errorMovie">
        <div class="player-wrapper">
          <h4 class="title">
            <span v-if="movie.categories.data.length">
              {{movie.categories.data[0].name}}:
            </span>
            {{movie.name}}
          </h4>
          <div v-if="!loadingVideoToPlay && !errorVideoToPlay">
            <VideoPlayer
                    v-if="videoToPlay"
                    :video="videoToPlay"
                    @videoEnded="videoEndedHandler"
                    @videoStarted="videoStartedHandler"
                    :showOverlay="videoToPlayShowTrailerEndingPromo"
                    :movie="movie"
            >
              <template
                      slot="overlay"
              >
                <div
                        class="player-overlay-subscribe"
                        :style="{ backgroundImage: `url('${backgroundGenericImage}')` }"
                >
                  <div
                          class="alert-box"
                          @click="subscribeHandler"
                  >
                    <p>
                      {{$t('video_watch.trailer.title')}}
                    </p>
                    <p>
                      {{$t('video_watch.trailer.subtitle')}}
                    </p>
                  </div>
                    <p class="close">
                        <a href="#!" @click="videoToPlayShowTrailerEndingPromo = false;">
                          {{$t('video_watch.trailer.buttons.close')}}
                        </a>
                    </p>
                </div>
              </template>
            </VideoPlayer>
            <div v-if="!videoToPlay">
              <div
                      :style="{ backgroundImage: `url('${movie.public_thumbnail_image_path['large']}')` }"
                      class="no-trailer-thumbnail"
                      @click="subscribeHandler"
              ></div>
            </div>
            <div v-if="!videoToPlayIsMain">
              <SubscriptionAdBar/>
            </div>
          </div>
          <div v-else class="video-box-fallback">
            <p v-if="errorVideoToPlay">
              {{$t('error')}}
            </p>
            <Spinner v-if="loadingVideoToPlay"/>
          </div>
          <div class="details">
            <!--
            <div class="stats">
              <div class="left">
                <div
                        class="rating"
                        :class="{liked: movie.interaction.liked}"
                        @click="likeHandler()"
                &gt;
                  {{$tc('video_watch.interactions.likes', movie.likes, {likes: $n(movie.likes)})}}
                </div>
                <div
                        class="favorites"
                        :class="{favorited: movie.interaction.favorited}"
                        @click="favoriteHandler()"
                &gt;
                  {{$tc('video_watch.interactions.favorites', movie.favorites, {favorites: $n(movie.favorites)})}}
                </div>
              /div>
              <div class="right">
                <div class="view-count">
                  {{$tc('video_watch.interactions.views', movie.views, {views: $n(movie.views)})}}
                </div>
              </div>
            </div>
            -->
            <div class="information">
              <p v-if="$auth.ready() && (!$auth.check() || !$auth.user().membership_active)">
                <UnderVideoPromotionalBanners/>
              </p>
              <p>
                {{$t('video_watch.information.models')}}:
                <router-link
                        v-for="model in movie.models.data"
                        :key="model.id"
                        :to="{name: 'model.profile', params: {id: model.id}}"
                >
                  {{model.name}}
                </router-link>
                <span v-if="movie.models.data.length === 0">
                  {{$t('video_watch.information.not_specified')}}
                </span>
              </p>
              <p>
                {{$t('video_watch.information.categories')}}:
                <router-link
                        v-for="category in movie.categories.data"
                        :to="{name: 'video.search', query: {category_id: category.id}}"
                        :key="category.id"
                >
                  {{category.name}}
                </router-link>
                <span v-if="movie.categories.data.length === 0">
                  {{$t('video_watch.information.not_specified')}}
                </span>
              </p>

              <p>
                {{$t('video_watch.information.tags')}}:
                <router-link
                        v-for="tag in movie.tags.data"
                        :to="{name: 'video.search', query: {tag_id: tag.id}}"
                        :key="tag.id"
                >
                  {{tag.name}}
                </router-link>
                <span v-if="movie.tags.data.length === 0">
                  {{$t('video_watch.information.not_specified')}}
                </span>
              </p>

              <p v-if="movie.group.data.length !== 0">
                {{$t('video_watch.information.movie_group')}}:
                <router-link
                        :to="{name: 'video.search', query: {group_id: movie.group.data.id}}"
                >
                  {{movie.group.data.name}}
                </router-link>
              </p>

              <p>
                {{$t('video_watch.information.movie')}}:
                <span>
                  {{movie.name}}
                </span>
              </p>
            </div>
          </div>
        </div>

        <section
                class="more-from-same-group"
                v-if="movie.group.data.length !== 0"
        >
          <h1 class="title">
            {{$t('video_watch.movie_group_title', {movie_group: movie.group.data.name})}}
          </h1>
          <div
                  class="videos"
          >
            <VideoBox
                    v-for="sameGroupMovie in movie.group.data.movies.data"
                    :key="sameGroupMovie.id"
                    :video="sameGroupMovie"
            />
          </div>
        </section>

        <section
                class="more-from-same-models"
                v-if="movie.models.data.length"
        >
          <h1 class="title">
            {{$t('video_watch.more_of_the_same_model', {'model': movie.models.data[0].name})}}
          </h1>

          <ResourceScroller
                  v-if="sameModelMoviesScroller !== null"
                  :resource="sameModelMoviesScroller.resource"
                  :default-params="sameModelMoviesScroller.defaultParams"
                  :per-page="6"
          >
            <template slot-scope="{element}">
              <MovieBoxVerticalBig :movie="element"/>
            </template>
            <template slot="placeholder" slot-scope="data">
              <MovieBoxVerticalBig :placeholder="true"/>
            </template>
          </ResourceScroller>
        </section>
      </template>
      <template v-else>
        <div
                class="loading-video"
                v-if="loadingMovie"
        >
          <Spinner/>
        </div>
        <div
                class="error-video"
                v-if="errorMovie"
        >
          <i18n path="video_watch.not_available_with_link.first">
            <template v-slot:link>
              <router-link class="action" :to="{name: 'purchase.subscription', query: { plan: legacyPlanId }}">
                {{$t('video_watch.not_available_with_link.link')}}
              </router-link>
            </template>
          </i18n>
        </div>
      </template>

      <section
          v-if="(movie && !movie.models.data[0].webstar)"
          class="related-videos"
      >
        <h4 class="title">
          {{$t('video_watch.related_movies')}}
        </h4>
        <ResourceScroller
                v-if="relatedMoviesScroller !== null"
                :resource="relatedMoviesScroller.resource"
                :default-params="relatedMoviesScroller.defaultParams"
                :per-page="8"
        >
          <template slot-scope="{element}">
            <MovieBoxVerticalBig :movie="element"/>
          </template>
          <template slot="placeholder" slot-scope="data">
            <MovieBoxVerticalBig :placeholder="true"/>
          </template>
        </ResourceScroller>
      </section>
    </div>
  </LayoutDefault>
</template>

<script>
  import VideoBox from "../components/VideoBox";
  import VideoPlayer from "../components/VideoPlayer";
  import Spinner from "../components/Spinner";
  import SubscriptionAdBar from "../components/SubscriptionAdBar";

  import resources from '../resources';
  import EventBus from '../eventbus';
  import SubscriptionForm from "../components/Checkout/SubscriptionForm";

  import ResourceScroller from "../components/ResourceScroller";
  import ModelBoxVerticalBig from "../components/ResourceScroller.ModelBox";
  import MovieBoxVerticalBig from "../components/ResourceScroller.MovieBox";
  import UnderVideoPromotionalBanners from "../components/UnderVideoPromotionalBanners";
  import LayoutDefault from "../layouts/LayoutDefault";

  export default {
    components: {
      LayoutDefault,
        UnderVideoPromotionalBanners,
      SubscriptionForm,
      SubscriptionAdBar,
      Spinner,
      VideoPlayer,
      VideoBox,
        ResourceScroller,
        MovieBoxVerticalBig,
        ModelBoxVerticalBig,
    },
    data(){
      return {
        movie: null,
        loadingMovie: true,
        errorMovie: false,

        videoToPlay: null,
        errorVideoToPlay: false,
        videoToPlayIsMain: false,
        loadingVideoToPlay: false,
        videoToPlayShowTrailerEndingPromo: false,

        reportedView: false,

        legacyPlanId: null
      }
    },
    methods: {
      videoStartedHandler(){
          if (!this.reportedView && this.videoToPlayIsMain){
              this.reportView();
          }

          this.videoToPlayShowTrailerEndingPromo = false;
      },
      videoEndedHandler(){
          if(!this.videoToPlayIsMain){
              this.videoToPlayShowTrailerEndingPromo = true;
          }
      },
      subscribeHandler(){
        this.$router.push({name: 'purchase.subscription'});
      },

      loadMovie(id){
        this.movie = null;
        this.errorMovie = false;
        this.loadingMovie = true;

        this.videoToPlay = null;
        this.videoToPlayIsMain = false;
        this.loadingVideoToPlay = false;
        this.errorVideoToPlay = false;
        this.videoToPlayShowTrailerEndingPromo = false;

        resources.movies.get({id: id, include: ['categories', 'models', 'tags', 'group.movies']})
          .then(response => {
              this.movie = response.data.data;
              this.errorMovie = false;
              this.loadingMovie = false;

              /* Si el video puede ser reproducido, cargamos el video, Si no mostramos el trailer */
              if (this.movie.main_video_id){ /* El main movie id viene vacio si no tenemos acceso */

                  this.videoToPlayIsMain = true;
                  this.loadVideo(this.movie.main_video_id);

              }else if(this.movie.trailer_video_id){

                  this.loadVideo(this.movie.trailer_video_id);

              }else{

                  //this.errorMovie = true;
                  //console.error('No hay video disponible');
              }
              /* Si el video puede ser reproducido, cargamos el video, Si no mostramos el trailer */
          }).catch(err => {

              this.loadingMovie = false;
              this.errorMovie = true;

              if (!this.legacyPlanId && err.body.fallback) {
                  this.legacyPlanId = err.body.fallback.legacy_plan_id;
              }
          });
      },

      loadVideo(videoId){
          this.videoToPlay = null;
          this.loadingVideoToPlay = true;
          this.errorVideoToPlay = false;

          resources.videos.get({id: videoId, cdn_cache_optimizer: Math.random() * 1000000000})
            .then((response) => {
                this.videoToPlay = response.data.data;
                this.loadingVideoToPlay = false;
                this.errorVideoToPlay = false;

            }).catch((err) => {
                this.loadingVideoToPlay = false;
                this.errorVideoToPlay = true;
            })
      },

      reportView(){
          this.reportedView = true;
          resources.movieView.store({movie_id: this.movie.id}).then(() => {
              this.$set(this.movie, 'views', this.movie.views + 1);
          });
      },

      favoriteHandler(intention){

          if(!this.$auth.check()){
              return EventBus.requireAuthentication(() => {
                  /*Si no estaba logueado asumimos que el quiso darle fav, no cambiar el fav por lo contrario */
                  this.favoriteHandler(true);
              });
          }

          if((intention !== undefined && !intention) || this.movie.interaction.favorited){
              this.$set(this.movie.interaction, 'favorited', false);

              resources.movieFavorites.delete({id: this.movie.id})
                .then(() => {
                    this.$set(this.movie, 'favorites', this.movie.favorites - 1);
                }).catch(() => {
                    this.$set(this.movie.interaction, 'favorited', true);
                });
          }else{
              this.$set(this.movie.interaction, 'favorited', true);

              resources.movieFavorites.store({movie_id: this.movie.id})
                .then(() => {
                    this.$set(this.movie, 'favorites', this.movie.favorites + 1);
                }).catch(() => {
                    this.$set(this.movie.interaction, 'favorited', false);
                });
          }
      },

      likeHandler(intention){
          if(!this.$auth.check()){
              return EventBus.requireAuthentication(() => {
                  /*Si no estaba logueado asumimos que el quiso darle like, no cambiar el like por lo contrario */
                  this.likeHandler(true);
              });
          }

          if((intention !== undefined && !intention) || this.movie.interaction.liked){
              this.$set(this.movie.interaction, 'liked', false);

              resources.movieLikes.delete({id: this.movie.id})
                  .then(() => {
                      this.$set(this.movie, 'likes', this.movie.likes - 1);
                  }).catch(() => {
                      this.$set(this.movie.interaction, 'liked', true);
                  });
          }else{
              this.$set(this.movie.interaction, 'liked', true);

              resources.movieLikes.store({movie_id: this.movie.id})
                  .then(() => {
                      this.$set(this.movie, 'likes', this.movie.likes + 1);
                  })
                  .catch(() => {
                      this.$set(this.movie.interaction, 'liked', false);
                  });
          }
      }
    },
    computed:{
        sameModelMoviesScroller(){
            if(this.loadingMovie || this.errorMovie || this.movie.models.data.length === 0){
                return null;
            }

            return {
                resource: resources.movies,
                defaultParams: {
                    include: [],
                    models: {
                        id: this.movie.models.data[0].id
                    }
                },
            };
        },
        backgroundGenericImage() {
          return this.movie.public_thumbnail_image_path['large'];
          // return '/img/wideo-w.jpg';
        },
        relatedMoviesScroller(){
            if(this.loadingMovie || this.errorMovie){
                return null;
            }

            return {
                resource: resources.movies,
                defaultParams: {
                    include: [],
                    related_to: {
                        id: this.movie.id
                    }
                },
            };
        },
    },
    watch:{
        movie(){
            this.reportedView = false;
        }
    },
    mounted(){
        this.loadMovie(this.$route.params.id);

        EventBus.$on('languageChanged', () => {
            this.loadMovie(this.$route.params.id);
        });
    },
    beforeRouteUpdate (to, from, next) {
        this.loadMovie(to.params.id);

        next();
    },
    beforeDestroy(){
      clearTimeout(this.viewTimeout);
    }
  }
</script>

<style scoped lang="scss">
  @import '../styles/variables';

  #watch{
    padding: 30px 7px 50px 7px;

    .no-trailer-thumbnail{
      background-color: var(--pallete_dark_color);
      height: 500px;
      width: 100%;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    .video-box-fallback{
      background-color: lightgrey;
      height: 500px;
      width: 100%;
      text-align: center;
      padding: 1em;
    }

    .player-wrapper{
      display: block;
      margin: auto;
      max-width: 70%;

      @media(max-width: 900px){
        max-width: 100%;
      }

      .title{
        text-align: left;
        margin: 0;
        margin-bottom: 10px;
      }

      .details{
        .stats{
          user-select: none;
          overflow: hidden;
          padding: 10px 0;
          font-size: .85em;
          line-height: 1em;

          .left{
            float: left;
          }

          .right{
            float: right;
          }

          .rating{
            float: left;
            cursor: pointer;

            &.liked{
              font-weight: bold;
            }

            &:before{
              //vertical-align: bottom;
              content:"";
              background-image: url('/img/ico/thumb-up.svg');
              //font-weight: bolder;
              //font-size: 2em;

            }
          }
          .favorites{
            margin-left: 1em;
            float: left;
            cursor: pointer;

            &.favorited{
              font-weight: bold;
            }

            &:before{
              vertical-align: bottom;
              //content: '♥';
              font-weight: bolder;
              font-size: 2em;
            }
          }
          .view-count{
            font-weight: bolder;
          }
        }

        .information{
          margin-top: 15px;
          text-align: left;

          p{
            margin: 0;

            a{
              text-decoration: underline;
              margin: 0 5px;
            }
          }
        }
      }

    }
    .more-from-same-models{
      margin-bottom: 75px;
      margin-top: 35px;

      .title{
        font-size: 40px;
        text-transform: uppercase;
        color: var(--pallete_main_color);
        margin: 0 0 20px 0;

        @media (max-width: 900px){
          font-size: 1.25em;
        }
      }

      .movie{
        width: 300px;

        &.horizontal{
          width: 500px;
        }
      }
    }

    .more-from-same-group{
      margin-bottom: 75px;
      margin-top: 35px;

      .title{
        font-size: 1.4em;
        text-align: left;
        margin: 5px;
        margin-bottom: 15px;
        text-transform: uppercase;
      }

      .videos{
        display: flex;
        flex-wrap: wrap;

        .video{
          flex-basis: 25%;
          flex-grow: 0;

          @media(max-width: 900px){
            flex-basis: 50%;
          }

          @media(max-width: 600px){
            flex-basis: 100%;
          }
        }
      }
    }

    .related-videos{

      .title{
        font-size: 1.4em;
        text-align: left;
        margin: 5px;
        margin-bottom: 15px;
        text-transform: uppercase;
      }

      .movie{
        width: 300px;

        &.horizontal{
          width: 500px;
        }
      }
    }
  }

  .player-overlay-subscribe{
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    user-select: none;
    background-color: var(--pallete_main_color);
    color: #ffffff;
    padding: .5em;
    font-weight: bold;
    text-transform: uppercase;
    height: 100%;
    opacity: .9;

  .alert-box{
    cursor: pointer;
    color: var(--pallete_main_color);
    padding: 1em;
      background-color: rgba(255,255,255,.75);
      box-shadow: 2px 2px 2px rgba(0,0,0, .5);
  }

    .close{

    }
  }

  .action {
    color: var(--pallete_main_color);
  }
</style>